import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "tooltip"]
  static outlets = ["vehicle-sortable"]
  
  connect() {
    
    this.isActive = false
    this.updateButtonState()
    
  }

  toggle() {
    this.isActive = !this.isActive
    
    // Conectar ao controller de sortable
    const vehiclesList = document.querySelector('[data-controller*="vehicle-sortable"]')
    
    if (vehiclesList) {
      const sortableController = this.application.getControllerForElementAndIdentifier(vehiclesList, 'vehicle-sortable')
      
      if (sortableController) {
        if (this.isActive) {
          sortableController.activate()
        } else {
          sortableController.deactivate()
        }
      }
    }
    
    this.updateButtonState()
    this.updateTooltip()
  }

  updateButtonState() {
    
    if (this.hasButtonTarget) {
      if (this.isActive) {
        this.buttonTarget.classList.add('active')
      } else {
        this.buttonTarget.classList.remove('active')
      }
      
    } else {
    }
  }

  updateTooltip() {
    
    if (this.hasTooltipTarget) {
      const newText = this.isActive ? 'Sair do modo reorganizar' : 'Reorganizar cards'
      this.tooltipTarget.textContent = newText
    } else {
    }
  }
}